import { Platform, StyleSheet } from 'react-native'
import { ApplicationStyles, Metrics } from 'APP/Themes'

export const Styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    ...Platform.select({
      web: {
        borderRadius: Metrics.baseMargin * 1.25,
        overflow: 'hidden' as const,
        ...ApplicationStyles.shadow,
      },
    }),
    marginTop: Platform.select({ web: Metrics.baseMargin * 2, default: 0 }),
    marginBottom: Platform.select({ web: Metrics.baseMargin * 2, default: Metrics.baseMargin / 2 }),
    marginHorizontal: Metrics.baseMargin,
  },
})
